module.exports = {
  footerText: 'Şantiye360 © 2025',
}
